import React from "react";

import { Header } from "@/components/Layout/Header";
import { PageLayout } from "@/components/Layout/PageLayout";

import ProjectsHeader from "./components/ProjectsHeader";

export default function ProjectTasks() {
  return (
    <PageLayout>
      <Header title={<>Projects</>} />
      <ProjectsHeader />
      <div>Project Tasks</div>
    </PageLayout>
  );
}
